import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import React from "react";
import { Link } from "react-router-dom";
const LogoutContent = (props) => {
    const device = DeviceContext();
    return (React.createElement("div", { className: device && device.isDesktop
            ? "logoutcontent-desktop"
            : "logoutcontent-desktop mx-0" },
        React.createElement("span", { className: "DMSan_16_700 txt-midnight-blue d-flex" }, props.userName),
        React.createElement("div", { className: "d-flex mgt-15" },
            React.createElement("span", { className: "DMSanN_14_400 txt_primaryGrey" }, "Cust ID"),
            React.createElement("span", { className: "DMSanM_14_500 ps-2 txt_blackOne1" }, "45015214")),
        React.createElement("div", { className: "d-flex mgt-15" },
            React.createElement("span", { className: "DMSanN_14_400 txt_primaryGrey" }, "Advisor"),
            React.createElement("span", { className: "DMSanM_14_500 ps-2 txt-midnight-blue txt_underline" }, "Rahul Bhattacharya")),
        React.createElement("div", null,
            React.createElement("div", { className: "d-flex mgt-15 viewprofile-section" },
                React.createElement("div", { className: "DMSanM_14_500 txt-midnight-blue" },
                    React.createElement(Link, { to: "/profile", className: "DMSanM_14_500 txt-midnight-blue lh-140" }, "view Profile")),
                React.createElement("span", { className: "edel-icon-arrow-right" })))));
};
export default LogoutContent;
